module.exports = __webpack_public_path__ + "img/emoticon-nps-6-off.c311a7ab.svg";